import pkg from '../../../../package.json';
import { AppConfig } from '../app/models/config.model';

export const environment: AppConfig = {
    production: true, // true environment.prod.ts
    client: 'sunology',
    projet: 'stream',
    module: 'mobile',
    env: 'recette',
    version: pkg.version,
    urlBackend: 'https://backend-mobile.sunology-stream-recette.emotic.fr',
};
